module.exports = __webpack_public_path__ + "media/images/pic/brodno/team/teachers/paulina-kozlowska-08d240ca77f8e7838a8b577670f4f0fc.webp";